/*!
 * KoliBri - The accessible HTML-Standard
 */
import { r as registerInstance, h, g as getElement } from './index-C_ZKddLG.js';
import { a as __rest } from './tslib.es6-QNbPBOk5.js';
import { e as KolDialogWcTag, a as KolAlertWcTag, p as KolInputCheckboxTag, q as KolInputNumberTag, b as KolButtonWcTag } from './component-names-DwvrfFak.js';
import { t as translate } from './i18n-CvFPh0g5.js';
import { d as dispatchDomEvent, K as KolEvent } from './events-BhfZTW2e.js';
import './common-D-vggmh2.js';
import './i18n-C73LqPIs.js';

const parseColumnWidth = (width) => {
    return Number.isFinite(width) && width !== undefined && width > 0 ? width : undefined;
};

const KolTableSettings = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.headerCells = [];
        this.editingHeaderCells = [];
        this.errorMessage = null;
        this.translateTableSettings = translate('kol-table-settings');
        this.translateTableSettingsCancel = translate('kol-table-settings-cancel');
        this.translateTableSettingsApply = translate('kol-table-settings-apply');
        this.translateErrorAllInvisible = translate('kol-table-settings-error-all-invisible');
        this._horizontalHeaderCells = [];
    }
    handleHeaderCellsChange(newValue) {
        this.headerCells = newValue.map((row) => [...row]);
        this.editingHeaderCells = newValue.map((row) => row.map((cell) => (Object.assign({}, cell))));
    }
    componentWillLoad() {
        this.handleHeaderCellsChange(this._horizontalHeaderCells);
    }
    getPrimaryRow() {
        var _a;
        return (_a = this.editingHeaderCells[this.editingHeaderCells.length - 1]) !== null && _a !== void 0 ? _a : [];
    }
    updatePrimaryRow(newRow) {
        this.editingHeaderCells = this.editingHeaderCells.map((row, index, arr) => (index === arr.length - 1 ? newRow : row));
    }
    moveColumn(columnId, direction) {
        const row = [...this.getPrimaryRow()];
        const sourceIndex = row.findIndex((col) => col.key === columnId);
        if (sourceIndex === -1)
            return;
        let targetIndex;
        if (direction === 'up') {
            if (sourceIndex === 0)
                return;
            targetIndex = sourceIndex - 1;
        }
        else {
            if (sourceIndex === row.length - 1)
                return;
            targetIndex = sourceIndex + 1;
        }
        const [source] = row.splice(sourceIndex, 1);
        row.splice(targetIndex, 0, source);
        this.updatePrimaryRow(row);
    }
    handleVisibilityChange(key, visible) {
        const row = this.getPrimaryRow().map((col) => (col.key === key && col.hidable !== false ? Object.assign(Object.assign({}, col), { visible: Boolean(visible) }) : col));
        this.updatePrimaryRow(row);
    }
    handleWidthChange(key, width) {
        const parsedWidth = parseColumnWidth(Number(width));
        const row = this.getPrimaryRow().map((col) => (col.key === key && col.resizable !== false ? Object.assign(Object.assign({}, col), { width: parsedWidth }) : col));
        this.updatePrimaryRow(row);
    }
    handleCancel() {
        var _a;
        this.editingHeaderCells = this.headerCells.map((row) => [...row]);
        this.errorMessage = null;
        void ((_a = this.dialogRef) === null || _a === void 0 ? void 0 : _a.close());
    }
    handleSubmit(event) {
        var _a;
        event.preventDefault();
        const primaryRow = this.getPrimaryRow();
        const hasVisibleColumn = primaryRow.some((column) => column.visible !== false);
        if (!hasVisibleColumn) {
            this.errorMessage = this.translateErrorAllInvisible;
            return;
        }
        else if (this.host) {
            this.errorMessage = null;
            this.headerCells = this.editingHeaderCells.map((row) => row.map((cell) => (Object.assign({}, cell))));
            const sanitizedHeaderCells = this.editingHeaderCells.map((row) => row.map((column) => {
                const _a = column, { hidable, resizable, sortable, visible, width } = _a, rest = __rest(_a, ["hidable", "resizable", "sortable", "visible", "width"]);
                const cell = Object.assign({}, rest);
                if (visible !== undefined)
                    cell.visible = visible;
                if (hidable !== undefined)
                    cell.hidable = hidable;
                if (sortable !== undefined)
                    cell.sortable = sortable;
                if (resizable !== undefined)
                    cell.resizable = resizable;
                if (width !== undefined && width !== null)
                    cell.width = width;
                return cell;
            }));
            dispatchDomEvent(this.host, KolEvent.changeHeaderCells, sanitizedHeaderCells);
            void ((_a = this.dialogRef) === null || _a === void 0 ? void 0 : _a.close());
        }
    }
    render() {
        const columns = this.getPrimaryRow();
        const onOpenDialog = {
            onClick: () => { var _a; return (_a = this.dialogRef) === null || _a === void 0 ? void 0 : _a.showModal(); },
        };
        return (h("div", { key: '44a8d6968edf05923489a760c334df308e100d45' }, h(KolButtonWcTag, { key: 'f3f3cf7d45448ca7513953697ee91800ed5bcd8c', class: "kol-table-settings", _icons: "kolicon-settings", _label: this.translateTableSettings, _hideLabel: true, _on: onOpenDialog }), h(KolDialogWcTag, { key: '807825a32a0e11af249a51e257d791f9558d9c0c', _label: this.translateTableSettings, _variant: "card", ref: (el) => (this.dialogRef = el), _width: "fit-content" }, h("div", { key: 'a4553872be9da42062ce93b85367d86845c5e0e6', class: "kol-table-settings__content" }, this.errorMessage && h(KolAlertWcTag, { key: 'c5557d75ec11e1bf6c585b53efe400c5ccb45b77', _type: "error", _label: this.errorMessage, _variant: "msg", class: "kol-table-settings__error-message" }), h("form", { key: 'b72f947c448bd6695dbfc8e352ea4a1d51c255a5', onSubmit: this.handleSubmit.bind(this) }, h("div", { key: '5ae19989bb7116028e6cf98b04640721cdc4200e', class: "kol-table-settings__columns" }, columns.map((column, index) => (h("div", { key: column.key, class: "kol-table-settings__column" }, h(KolInputCheckboxTag, { _checked: column.visible !== false, _label: column.hidable
                ? translate('kol-table-settings-column-hidable', { placeholders: { column: column.label } })
                : translate('kol-table-settings-column-not-hidable', { placeholders: { column: column.label } }), _value: true, _hideLabel: true, _disabled: column.hidable === false, _on: { onInput: (_, value) => { var _a; return this.handleVisibilityChange((_a = column.key) !== null && _a !== void 0 ? _a : '', value); } } }), h("span", { class: "kol-table-settings__column-label" }, column.label), h(KolInputNumberTag, { _hideLabel: true, _value: parseColumnWidth(column.width), _label: translate('kol-table-settings-column-width', { placeholders: { column: column.label } }), _min: 1, _disabled: column.resizable === false, _on: { onInput: (_, value) => { var _a; return this.handleWidthChange((_a = column.key) !== null && _a !== void 0 ? _a : '', value); } } }), h(KolButtonWcTag, { _icons: "kolicon-chevron-up", _label: column.sortable === false || index === 0
                ? translate('kol-table-settings-not-move', { placeholders: { column: column.label } })
                : translate('kol-table-settings-move-up', { placeholders: { column: column.label } }), _hideLabel: true, _variant: "ghost", _on: { onClick: () => { var _a; return this.moveColumn((_a = column.key) !== null && _a !== void 0 ? _a : '', 'up'); } }, _disabled: column.sortable === false || index === 0, "data-testid": "table-settings-move-up" }), h(KolButtonWcTag, { _icons: "kolicon-chevron-down", _label: column.sortable === false || index === columns.length - 1
                ? translate('kol-table-settings-not-move', { placeholders: { column: column.label } })
                : translate('kol-table-settings-move-down', { placeholders: { column: column.label } }), _hideLabel: true, _variant: "ghost", _on: { onClick: () => { var _a; return this.moveColumn((_a = column.key) !== null && _a !== void 0 ? _a : '', 'down'); } }, _disabled: column.sortable === false || index === columns.length - 1, "data-testid": "table-settings-move-down" }))))), h("div", { key: '97eded2b81ac73aee1586d3d5eae15e6465c3e4c', class: "kol-table-settings__actions" }, h(KolButtonWcTag, { key: '07a475b56d11261c6ddd21ba1eafdcb2b9d7cc60', _label: this.translateTableSettingsCancel, _variant: "secondary", _on: { onClick: () => this.handleCancel() }, "data-testid": "table-settings-cancel" }), h(KolButtonWcTag, { key: '538ae0b53cbd870ecc586f34d1132e9909768752', _label: this.translateTableSettingsApply, _variant: "primary", _type: "submit", "data-testid": "table-settings-apply" })))))));
    }
    get host() { return getElement(this); }
    static get watchers() { return {
        "_horizontalHeaderCells": ["handleHeaderCellsChange"]
    }; }
};

export { KolTableSettings as kol_table_settings_wc };
//# sourceMappingURL=kol-table-settings-wc.entry.js.map
